export default __webpack_public_path__ + "static/media/circle.d39ad58a.png";